// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dUtC","colMin":"styles_colMin__2Rm8Q"};